
const aboutPageStyle = {
    version: {
        marginTop:"50px"
    }
};

export default aboutPageStyle;
